import React from 'react'
import { IconProps } from '../types'

export default function AiBadgeIcon({
    className = 'h-[12px] w-[12px]',
    fill = '#0A84FF',
    stroke = '#0A84FF',
    ...props
}: IconProps) {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <rect width="12" height="12" rx="6" fill={fill} fillOpacity={0.1} />
            <rect
                x="0.25"
                y="0.25"
                width="11.5"
                height="11.5"
                rx="5.75"
                fill="none"
                stroke={stroke}
                strokeOpacity={0.2}
                strokeWidth={0.5}
            />
            <path
                d="M3.84801 8H3.14915L4.71946 3.63636H5.48011L7.05043 8H6.35156L5.1179 4.42898H5.08381L3.84801 8ZM3.9652 6.29119H6.23224V6.84517H3.9652V6.29119ZM8.33896 3.63636V8H7.68058V3.63636H8.33896Z"
                fill={fill}
            />
        </svg>
    )
}
